import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getConfig } from "./api";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState("CZK");
  const [czkPerEur, setCzkPerEur] = useState(25);

  useEffect(() => {
    getConfig()
      .then((c) => {
        if (c?.czk_per_eur) setCzkPerEur(Number(c.czk_per_eur));
      })
      .catch(() => {});
  }, []);

  const convert = useCallback(
    (amountCzk) => (currency === "EUR" ? Number(amountCzk) / czkPerEur : Number(amountCzk)),
    [currency, czkPerEur]
  );

  const symbol = currency === "EUR" ? "\u20ac" : "K\u010d";

  const fmt = useCallback(
    (amountCzk, decimals = 0) => {
      const value = convert(amountCzk);
      const str = value.toLocaleString("cs-CZ", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
      return `${str} ${symbol}`;
    },
    [convert, symbol]
  );

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, czkPerEur, convert, fmt, symbol }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
